import { FilterFieldsOptions } from '@ui/ui.module';

export interface UsersFilter {
  role?: string;
  username?: string;
}

export const UsersFiltersMeta: FilterFieldsOptions<UsersFilter> = {
  role: { operator: 'equal', typeField: 'oid' },
  username: { operator: 'begins_with' },
};
